import React from "react";
import "./AddonStatus.css"
import StatusCard from "./StatusCard";
import useStatus from "./useStatus"; // ✅ fixed path

function AddonStatus() {
  const { services, global } = useStatus();

  return (
    <div className="container">
      <h1>🧱 Network Status</h1>

      <h2 className={global.color}>{global.status}</h2>
      <p>Last updated: {global.lastUpdated}</p>

      <div className="cards">
        {services.map((service, i) => (
          <StatusCard
            key={i}
            title={service.name}
            status={
              service.info
                ? `${service.status} (${service.info})`
                : service.status
            }
            color={service.color}
          />
        ))}
      </div>
    </div>
  );
}
export default AddonStatus;